<div
  class="editor-all editor-interior"
  [ngClass]="{'no-right-menu': !displayRightMenu}"
  *ngIf="editorType.ready"
>
  <editor-topbar
    [vm]="this"
    [selection]="'interior'"
    [cabinetSection]="cabinetSection"
  ></editor-topbar>

  <dark-side-bar [floorplan]="floorPlan"></dark-side-bar>

  <div
    class="tool-menu left-tool-menu with-ribbon"
    style="display: flex; flex-flow: column nowrap"
  >
    <product-list
      class="vertical"
      (onProductClick)="createItemFromProduct($event)"
      (onCategoryChange)="categoryChanged($event)"
      [cabinetSection]="cabinetSection!"
    ></product-list>
  </div>

  <div class="ribbon-menu">
    <div class="ribbon-block checkbox-ribbon-block visibility">
      <label>
        <input type="checkbox" [(ngModel)]="showRulers" />
        {{translate('editor_label_show_rulers', 'Rulers')}}
      </label>
      <label *ngIf="showShowPullout">
        <input type="checkbox" [(ngModel)]="showPullout" />
        {{translate('editor_label_show_pullout', 'Pullout Warnings')}}
      </label>
      <label>
        <input type="checkbox" [(ngModel)]="showCorpus" />
        {{translate('editor_label_show_corpus', 'Corpus')}}
      </label>
      <label *ngIf="showShowHinges">
        <input type="checkbox" [(ngModel)]="showHinges" />
        {{translate('editor_swing_show_hinges', 'Show hinges')}}
      </label>
      <label *ngIf="showShowDoors">
        <input type="checkbox" [(ngModel)]="showSwingFlexDoors" />
        {{translate('editor_swing_show_doors', 'Show doors')}}
      </label>
    </div>

    <div class="ribbon-block material">
      <pickable
        (click)="selectInteriorMaterial()"
        [pickable]="interiorMaterial"
        class="material interior-material modal-opener"
      ></pickable>
    </div>

    <div class="ribbon-block checkbox-ribbon-block" *ngIf="showDepthAdjustment">
      <label
        [ngStyle]="{visibility: isHeightReductionAllowed ? 'visible' : 'hidden'}"
      >
        <input type="checkbox" [(ngModel)]="heightReduction" />
        {{translate('editor_label_height_reduction', 'Height reduction')}}
      </label>
      <div class="input-group input-group-sm" [attr.title]="depthTooltip">
        <span
          class="input-group-text"
          [textContent]="translate('editor_interior_interior_depth', 'Depth')"
        ></span>
        <input
          class="form-control"
          id="interior-depth"
          type="number"
          [value]="depth"
          (change)="updateInteriorDepth($event, cabinetSection!)"
          [attr.min]="minDepth"
          [attr.max]="maxDepth"
          [disabled]="minDepth === maxDepth"
          [class.invalid]="isDepthInvalid()"
        />
        <span class="input-group-text">mm</span>
      </div>
    </div>

    <div class="ribbon-block favourites">
      <div class="btn-group btn-group-sm">
        <div
          class="btn-group btn-group-sm"
          ngbDropdown
          *ngIf="showFavourites"
          [open]="isFavoritesMenuOpen"
        >
          <button class="btn btn-default" ngbDropdownToggle>
            <span
              [textContent]="translate('editor_interior_title_select_favourites', 'Favourites')"
            ></span>
            <span class="bi bi-caret-down-fill"></span>
          </button>
          <ul class="dropdown-menu" ngbDropdownMenu>
            <li role="menuitem">
              <a
                [textContent]="translate('editor_interior_title_select_favourites', 'Load favourite')"
                (click)="selectFavourites()"
              ></a>
            </li>
            <li role="menuitem">
              <a
                (click)="saveAsFavourite()"
                [textContent]="translate('editor_interior_title_save_favourite', 'Save as favourite')"
              ></a>
            </li>
          </ul>
        </div>
        <div
          class="btn-group btn-group-sm"
          ngbDropdown
          *ngIf="showAdvanced"
          [open]="isAdvancedMenuOpen"
        >
          <button class="btn btn-default" ngbDropdownToggle>
            <span
              [textContent]="translate('editor_interior_ribbon_advanced', 'Advanced')"
            ></span>
            <span class="bi bi-caret-down-fill"></span>
          </button>
          <ul class="dropdown-menu dropdown-menu-right" ngbDropdownMenu>
            <li role="menuitem">
              <a
                (click)="selectAll()"
                [textContent]="translate('editor_interior_ribbon_advanced_select_all', 'Select All')"
              ></a>
            </li>
            <li role="menuitem" [ngClass]="{'disabled': !canChangeItemDepths}">
              <a
                (click)="changeItemDepths()"
                [textContent]="translate('editor_interior_ribbon_advanced_change_depth', 'Change selected item depths')"
              ></a>
            </li>
            <li role="menuitem">
              <a
                (click)="changeHerringBonePosition()"
                [textContent]="translate('editor_interior_ribbon_advanced_herring_position', 'Change herringbone position')"
              ></a>
            </li>
            <li role="menuitem">
              <a
                (click)="setFreeSpace()"
                [textContent]="translate('editor_interior_ribbon_advanced_free_space', 'Change free space')"
              ></a>
            </li>
            <li role="menuitem">
              <a
                (click)="fitToWidth()"
                [textContent]="translate('editor_interior_ribbon_advanced_fit_to_width', 'Fit to width')"
              ></a>
            </li>
          </ul>
        </div>
        <div
          class="btn-group btn-group-sm"
          ngbDropdown
          *ngIf="showMaterialsMenu"
          [open]="isMaterialsMenuOpen"
        >
          <button class="btn btn-default" ngbDropdownToggle>
            <span
              [textContent]="translate('editor_interior_ribbon_materials', 'Materials')"
            ></span>
            <span class="bi bi-caret-down-fill"></span>
          </button>
          <div class="dropdown-menu" ngbDropdownMenu role="menu">
            <ul class="pickable-dropdown">
              <li class="no-margin" *ngIf="canSetFrameColor">
                <h3
                  [textContent]="translate(
                'editor_interior_material_dropdown_frame_color',
                'frame color'
              )"
                ></h3>
              </li>
              <li role="menuitem" *ngIf="canSetFrameColor">
                <pickable
                  [pickable]="frameColorPickable"
                  class="modal-opener material"
                  (click)="selectFrameColor()"
                />
              </li>

              <li class="no-margin" *ngIf="canSetCableTrayColor">
                <h3
                  [textContent]="translate(
                'editor_interior_material_dropdown_cable_tray_color',
                'Cable Tray'
              )"
                ></h3>
              </li>
              <li role="menuitem" *ngIf="canSetCableTrayColor">
                <select
                  [(ngModel)]="defaultCableTrayColorNumber"
                  class="form-select form-select-lg"
                >
                  <option
                    *ngFor="let ctc of cableTrayColors"
                    [value]="ctc.Number"
                  >
                    {{ctc.DefaultName}}
                  </option>
                </select>
              </li>
            </ul>
          </div>
        </div>
        <div
          class="btn-group btn-group-sm"
          ngbDropdown
          role="group"
          #gripsDropdown="ngbDropdown"
          autoClose="outside"
          *ngIf="showGripMenu"
        >
          <button class="btn btn-default" ngbDropdownToggle>
            <span
              [textContent]="translate('editor_swingflex_grip_dropdown', 'Grip')"
            ></span>
            <span class="bi bi-caret-down-fill"></span>
          </button>
          <div
            class="dropdown-menu"
            ngbDropdownMenu
            role="menu"
            style="padding-bottom: 0"
          >
            <ul class="pickable-dropdown">
              <li class="no-margin" *ngIf="isDrawerGripPossible">
                <h3
                  [textContent]="translate(
                'editor_interior_ribbon_grip_product_header',
                'Grip type'
              )"
                ></h3>
              </li>
              <li role="menuitem" *ngIf="isDrawerGripPossible">
                <pickable
                  [pickable]="drawerGripPickable"
                  class="modal-opener product grip-product"
                  (click)="selectDrawerGripForSection()"
                ></pickable>
              </li>

              <li class="no-margin" *ngIf="isDrawerGripMaterialPossible">
                <h3
                  [textContent]="translate(
                'editor_interior_ribbon_grip_material_header',
                'Grip material'
              )"
                ></h3>
              </li>

              <li role="menuitem" *ngIf="isDrawerGripMaterialPossible">
                <pickable
                  [pickable]="drawerGripMaterialPickable"
                  class="modal-opener material grip-material"
                  (click)="selectDrawerGripMaterialForSection()"
                ></pickable>
              </li>
            </ul>
            <button class="btn" (click)="gripsDropdown.close()">
              {{ translate("button_close", "Close") }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="flex-spacer"></div>
    <div class="ribbon-block right-menu-visibility-ribbon-block">
      <button
        class="btn btn-default"
        (click)="displayRightMenu = !displayRightMenu"
      >
        <span
          class="glyphicon"
          [ngClass]="displayRightMenu ? 'bi-chevron-right' : 'bi-chevron-left'"
        ></span>
      </button>
    </div>
  </div>

  <interior2d
    *ngIf="!use3d"
    class="editor-center center-svg"
    [cabinetSection]="cabinetSection!"
    [showRulers]="showRulers"
    [showPullout]="showPullout"
    [showCorpus]="showCorpus"
    [showHeightReduction]="heightReduction"
    [showDummyItems]="true"
    [showWarnings]="true"
    [showHinges]="showHinges"
    [showSwingFlexDoors]="showSwingFlexDoors"
  ></interior2d>

  <div class="tool-menu right-tool-menu" [hidden]="!displayRightMenu">
    <div class="tool-menu-body">
      <item-editor
        [item]="selectedItem"
        (itemChanged)="selectedItemChanged()"
        *ngIf="selectedItem"
        class="item-editor"
      ></item-editor>

      <button
        class="btn btn-danger btn-block"
        (click)="deleteSelectedItem()"
        *ngIf="isSelectedItemDeletable"
        [textContent]="translate('interior_item_delete_button_text', 'Delete')"
      ></button>

      <div class="item-errors" *ngIf="selectedItem">
        <error-info
          *ngFor="let errorInfo of selectedItem.errors"
          [showLink]="false"
          [errorInfo]="errorInfo"
        ></error-info>
      </div>
    </div>
  </div>

  <corner-name-bubble [floorPlan]="floorPlan"></corner-name-bubble>
</div>
